import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  apiResendConfirmationRequest,
  resetResendConfirmation,
} from 'Redux/actions/signup';

/**
 * "Resend verification link" prompt. Used by an expired confirmation link, by a
 * password login that needs verification, and by the Google 409.
 */
const ResendConfirmation = ({ email, message }) => {
  const dispatch = useDispatch();
  const resend = useSelector(state => state.signup.resend);

  useEffect(() => () => dispatch(resetResendConfirmation()), []);

  if (resend.sent) {
    return (
      <div className="alert alert-success text-center mt-3" role="alert">
        Verification link sent. Check your inbox.
      </div>
    );
  }

  const error = resend.error;
  return (
    <div className="alert alert-warning text-center mt-3" role="alert">
      <div>{error?.detail || message}</div>
      {error?.code === 'account_not_found' && <Link to="/signup">Sign up</Link>}
      {error?.code === 'already_verified' && <Link to="/login">Log in</Link>}
      {!error?.code && (
        <button
          type="button"
          className="btn btn-link p-0"
          disabled={!email || resend.isLoading}
          onClick={() => dispatch(apiResendConfirmationRequest(email))}
        >
          Resend link
        </button>
      )}
    </div>
  );
};

export default ResendConfirmation;
